import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const walletSchemeViewRoute: RouteConfig<'with-page'> = {
    name: 'Wallet Scheme Breakdown',
    path: '/wallet/schemes/:schemeType',
    page: lazy(() => import('.')),
    flags: ['member-route', 'no-menu-item'],
    permissions: ['wallet'],
    context: 'member',
}